import { render, staticRenderFns } from "./_activities-tabs.vue?vue&type=template&id=63d728ae&scoped=true&"
import script from "./_activities-tabs.vue?vue&type=script&lang=ts&"
export * from "./_activities-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d728ae",
  null
  
)

export default component.exports